import React, { useState } from 'react';
import { string, bool } from 'prop-types';
import { Dropdown, DropdownAnchor, DropdownContent, DropdownMenu, MenuItem } from '@fiverr-private/dropdown';
import { getResourcesLinks } from '../shared/getResourcesLinks';
import ResourcesListItem from './ResourcesListItem';
import TriggerButton from './TriggerButton';

const ResourcesTab = ({ headerType = '', isTransparent = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const links = getResourcesLinks({ headerType });

    return (
        <Dropdown onOpenChanged={setIsOpen} width="350px" borderRadius="xl">
            <DropdownAnchor>
                <TriggerButton isTransparent={isTransparent} isOpen={isOpen} />
            </DropdownAnchor>
            <DropdownContent>
                <DropdownMenu maxHeight="auto">
                    {links.map((link) => (
                        <MenuItem key={link.key}>
                            <ResourcesListItem link={link} />
                        </MenuItem>
                    ))}
                </DropdownMenu>
            </DropdownContent>
        </Dropdown>
    );
};

ResourcesTab.propTypes = {
    headerType: string,
    isTransparent: bool,
};

export default ResourcesTab;
